import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./line_preview.less";

const LinePreview = ({ animated = false, content }) => (
  <div className={css.linePreview}>
    <svg
      viewBox="0 -300 330 330"
      className={classNames({ [css.linePreviewLoading]: animated }, css.linePreviewLine)}
    >
      <path
        id="line"
        d="M 0 0 L 150 -150 L 210 -105 L 320 -234 L 320 -220 L 211 -92 L 151 -137 L 14 0 Z"
        fill="#ffffff"
      />
    </svg>
    <h3>{content}</h3>
  </div>
);

LinePreview.propTypes = {
  animated: PropTypes.bool,
  content: PropTypes.string
};

export default LinePreview;
